import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const workspaceFeedbacks = createWorkspaceResourceApi('feedbacks')

export const feedbacksApi = {
  list: workspaceFeedbacks.list,
  get: workspaceFeedbacks.get,
  create: workspaceFeedbacks.create,
  meta: (workspaceId) => apiFetch(`${workspaceFeedbacks.path(workspaceId)}/meta`),
  addComment: (workspaceId, feedbackId, payload) =>
    apiFetch(`${workspaceFeedbacks.path(workspaceId)}/${feedbackId}/comments`, {
      method: 'POST',
      body: payload,
    }),

  // Admin (global) feedbacks
  adminList: (params) => apiFetch('feedbacks', { params }),
  adminGet: (feedbackId) => apiFetch(`feedbacks/${feedbackId}`),
  adminUpdate: (feedbackId, payload) =>
    apiFetch(`feedbacks/${feedbackId}`, { method: 'POST', body: payload }),
  adminMeta: () => apiFetch('feedbacks/meta', { ignoreGlobalCatch: true }),
}
